
function matomoEvt(action, name, value) {
    if (window._paq) {
        // console.log(`Matomo tracking: ${categorie} - ${action} - ${name}`);
        window._paq.push([
            'trackEvent',
            'Mecatheque',
            action,
            name,
            value
        ]);
    }
}

export default matomoEvt;